import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';

@Injectable()

export class FavoritesService {
  constructor(
    private http: HttpClient
  ) {}

  public getFavorites(data: string[]): Observable<Object> {
    return new Observable((observer) => {
      this.http.post(environment.apiUrl + '/favorites', data).subscribe((res) => {
        return observer.next(res);
      }, (err) => {
        return observer.error(err);
      });
    });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/app/components/favorites/favorites.service.ts